import { mapGetters } from 'vuex';
import { processList } from '../process-list.js';
import { errorMessage } from '@/utils/message.js';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import { changeSkin } from '@/utils/common.js';

export default {
  components: {
    ProcessNavigation
  },
  data() {
    return {
      isShowCheckCai: false,
      userTypeList: [],
      processList: processList
    };
  },
  created() {
    if (this.changeSkin() === 'caijiazhen') {
      this.isShowCheckCai = true;
    }
    // 获取用户类型列表
    this.getUserTypeList();
    const isFromSecond = this.$route.query && this.$route.query.from && this.$route.query.from === 'second';
    if (!isFromSecond) {
      // this.$store.commit('UPDATE_REGISTER_USER_TYPE', null);
      this.$store.commit('RESET_REGISTER_FIRST_STEP');
    }
    this.$store.commit('UPDATE_ACC_NAME', '' );
  },
  computed: {
    ...mapGetters([
      'userType'
    ])
  },
  methods: {
    changeSkin,
    // 获取字典：用户类型列表
    getUserTypeList() {
      this.$store.dispatch('getSelectDictList', 'USER_TYPE').then(res => {
        if (res.code === '0') {
          this.userTypeList = res.data;
        }
      });
    },
    // 更新用户类型
    updateUserType(type) {
      const userType = Number(type);
      this.$store.commit('UPDATE_REGISTER_USER_TYPE', userType);
    },
    next() {
      if (!this.userType) {
        errorMessage('请选择用户用户类型');
        return;
      }
      this.$router.push('/register/second-step');
    }
  }

};
